
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[p_name]",
      function () {
        return require("private-next-pages/product/[p_name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[p_name]"])
      });
    }
  